import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getFactorsAffectingCareSelector } from '../selectors/getFactorsAffectingCare.selector'
import { FactorsAffectingCareConstants } from '../store/factorsAffectingCare.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IFactorsAffectingCareState, IIFactorsOptions } from '../store/factorsAffectingCare.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import {
  setDispatchFactorsPNNV,
  setResponseFactorsPNNV,
  setSceneFactorsPNNV,
  setTransportFactorsPNNV,
  setTurnAroundFactorsPNNV,
} from '../store/factorsAffectingCare.actions'

export function* saveFactorsAffectingCare() {
  const factorsAffectingCareState: IFactorsAffectingCareState = yield select(getFactorsAffectingCareSelector)
  const {
    dispatchFactors,
    dispatchFactorsPNNV,
    responseFactors,
    responseFactorsPNNV,
    sceneFactors,
    sceneFactorsPNNV,
    turnAroundFactors,
    turnAroundFactorsPNNV,
    transportFactors,
    transportFactorsPNNV,
    factors,
    showDispatchFactors,
    showResponseSceneTransportFactors,
    showFactors,
    showTurnAroundFactors,
  } = factorsAffectingCareState
  const prFactors: IIFactorsOptions = []
  if (showDispatchFactors) {
    if (dispatchFactorsPNNV && dispatchFactors.length === 0) {
      prFactors.push({ ...dispatchFactorsPNNV, type: 3, otherComments: null })
    } else {
      dispatchFactors.forEach((factor) => prFactors.push({ ...factor, type: 3 }))
      yield put(setDispatchFactorsPNNV(null))
    }
  }
  if (showTurnAroundFactors) {
    if (turnAroundFactorsPNNV && turnAroundFactors.length === 0) {
      prFactors.push({ ...turnAroundFactorsPNNV, type: 4, otherComments: null })
    } else {
      turnAroundFactors.forEach((factor) => prFactors.push({ ...factor, type: 4 }))
      yield put(setTurnAroundFactorsPNNV(null))
    }
  }
  if (showResponseSceneTransportFactors) {
    if (responseFactorsPNNV && responseFactors.length === 0) {
      prFactors.push({ ...responseFactorsPNNV, type: 0, otherComments: null })
    } else {
      responseFactors.forEach((factor) => prFactors.push({ ...factor, type: 0 }))
      yield put(setResponseFactorsPNNV(null))
    }
    if (sceneFactorsPNNV && sceneFactors.length === 0) {
      prFactors.push({ ...sceneFactorsPNNV, type: 1, otherComments: null })
    } else {
      sceneFactors.forEach((factor) => prFactors.push({ ...factor, type: 1 }))
      yield put(setSceneFactorsPNNV(null))
    }
    if (transportFactorsPNNV && transportFactors.length === 0) {
      prFactors.push({ ...transportFactorsPNNV, type: 2, otherComments: null })
    } else {
      transportFactors.forEach((factor) => prFactors.push({ ...factor, type: 2 }))
      yield put(setTransportFactorsPNNV(null))
    }
  } else if (showFactors) {
    factors.forEach((factor) => prFactors.push({ ...factor, type: 0 }))
  }
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc, factorsAffectingCareState, factorsAffectingCare: { prFactors } }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveFactorsAffectingCare() error: ${e}`))
    }
  }
}

export function* saveFactorsAffectingCareSaga() {
  yield takeLatest(
    [
      FactorsAffectingCareConstants.SET_DISPATCH_FACTORS,
      FactorsAffectingCareConstants.SET_RESPONSE_FACTORS,
      FactorsAffectingCareConstants.SET_SCENE_FACTORS,
      FactorsAffectingCareConstants.SET_TRANSPORT_FACTORS,
      FactorsAffectingCareConstants.SET_TURN_AROUND_FACTORS,
      FactorsAffectingCareConstants.SET_FACTORS,
    ],
    performWithMutexHOG,
    saveFactorsAffectingCare
  )
}
